import makeStyles from "@mui/styles/makeStyles";
import { colors } from "@zapalacorp/tokens";

const useStyles = makeStyles(() => ({
  pageWrapper: {
    minHeight: "100vh",
    backgroundColor: colors.gray25,
    padding: "24px",
  },
  breadcrumbContainer: {
    marginBottom: "24px",
  },
  contentContainer: {
    maxWidth: "90%",
    margin: "0 auto",
    display: "flex",
    flexDirection: "column",
    gap: "20px",
  },
  paper: {
    backgroundColor: colors.white,
    borderRadius: "12px",
    boxShadow: "0px 1px 3px rgba(16, 24, 40, 0.1), 0px 1px 2px rgba(16, 24, 40, 0.06)",
  },
  sectionBody: {
    padding: "24px",
    display: "flex",
    flexDirection: "column",
    gap: "20px",
  },
  sectionHeaderRow: {
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
    width: "100%",
  },
  sectionTitle: {
    fontFamily: "Manrope",
    fontSize: "16px",
    fontWeight: 700,
    lineHeight: "24px",
    letterSpacing: "0.15px",
    color: "#475467",
    margin: 0,
  },
  emailEditorLayout: {
    display: "flex",
    gap: "24px",
    width: "100%",
    flexWrap: "wrap",
  },
  richTextPanel: {
    flex: 1,
    minWidth: "320px",
    display: "flex",
    flexDirection: "column",
    gap: "16px",
    backgroundColor: colors.gray50,
    borderRadius: "16px",
    border: `1px solid ${colors.gray200}`,
    padding: "20px",
  },
  tagChipRow: {
    display: "flex",
    flexWrap: "wrap",
    gap: "8px",
    padding: "12px 16px",
    backgroundColor: colors.white,
    border: `1px solid ${colors.gray200}`,
    borderTop: "none",
    borderRadius: "0 0 12px 12px",
  },
  tagChipButton: {
    borderRadius: "999px",
    border: `1px solid ${colors.gray300}`,
    backgroundColor: colors.white,
    padding: "6px 12px",
    display: "inline-flex",
    alignItems: "center",
    gap: "6px",
    fontFamily: "Manrope",
    fontWeight: 600,
    fontSize: "12px",
    color: "#475467",
  },
  tagChipLabel: {
    fontSize: "12px",
    lineHeight: "16px",
  },
  editorWorkspace: {
    backgroundColor: colors.white,
    borderRadius: "12px 12px 0 0",
    padding: "8px",
    border: `1px solid ${colors.gray200}`,
    borderBottom: "none",
    minHeight: "460px",
  },
  editorOptionRow: {
    borderTop: `1px solid ${colors.gray200}`,
    paddingTop: "12px",
    display: "flex",
    gap: "16px",
    flexWrap: "wrap",
  },
  editorOption: {
    display: "flex",
    alignItems: "center",
    gap: "6px",
  },
  editorOptionLabel: {
    fontFamily: "Manrope",
    fontSize: "14px",
    color: "#475467",
  },
  previewPanel: {
    flex: 1,
    minWidth: "320px",
    display: "flex",
    flexDirection: "column",
    borderRadius: "16px",
    border: `1px solid ${colors.gray200}`,
    backgroundColor: colors.white,
    boxShadow: "0px 1px 3px rgba(71, 84, 103, 0.15), 0px 1px 2px rgba(71, 84, 103, 0.3)",
  },
  previewBrowserChrome: {
    display: "flex",
    alignItems: "center",
    gap: "12px",
    padding: "8px 16px",
    backgroundColor: colors.gray200,
    borderRadius: "16px 16px 0 0",
  },
  previewTrafficLights: {
    display: "flex",
    gap: "6px",
  },
  previewTrafficDot: {
    width: "12px",
    height: "12px",
    borderRadius: "50%",
  },
  previewUrl: {
    flex: 1,
    borderRadius: "999px",
    backgroundColor: colors.gray100,
    padding: "4px 12px",
    fontFamily: "Manrope",
    fontSize: "12px",
    color: "#98A2B3",
  },
  previewChromeIcon: {
    color: "#475467",
  },
  previewBodyShell: {
    display: "flex",
    flexDirection: "column",
    gap: 0,
    padding: "24px 24px 32px",
    backgroundColor: colors.white,
    borderRadius: "0 0 16px 16px",
    maxHeight: "640px",
    overflowY: "auto",
    overflowX: "hidden",
  },
  previewPanelFullScreen: {
    width: "100%",
    height: "100%",
    display: "flex",
    flexDirection: "column",
    backgroundColor: colors.white,
  },
  emailPortalBody: {
    display: "flex",
    flex: 1,
    minHeight: 0,
    backgroundColor: colors.gray50,
  },
  emailPortalSidebar: {
    width: "340px",
    minWidth: "340px",
    borderRight: `1px solid ${colors.gray200}`,
    backgroundColor: colors.white,
    display: "flex",
    flexDirection: "column",
    minHeight: 0,
  },
  emailPortalSidebarTitle: {
    fontFamily: "Manrope",
    fontSize: "16px",
    fontWeight: 700,
    lineHeight: "24px",
    color: "#475467",
    padding: "16px 20px",
    borderBottom: `1px solid ${colors.gray200}`,
    margin: 0,
  },
  emailPortalList: {
    display: "flex",
    flexDirection: "column",
    gap: "8px",
    padding: "12px",
    overflowY: "auto",
    minHeight: 0,
  },
  emailPortalListItem: {
    border: `1px solid ${colors.gray200}`,
    borderRadius: "10px",
    padding: "12px",
    backgroundColor: colors.white,
  },
  emailPortalListItemActive: {
    border: `1px solid ${colors.brandBlue500}`,
    borderRadius: "10px",
    padding: "12px",
    backgroundColor: "#EFF8FF",
  },
  emailPortalListItemHeader: {
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
    gap: "8px",
    marginBottom: "4px",
  },
  emailPortalSender: {
    fontFamily: "Manrope",
    fontSize: "13px",
    fontWeight: 700,
    lineHeight: "18px",
    color: "#344054",
  },
  emailPortalTime: {
    fontFamily: "Manrope",
    fontSize: "12px",
    lineHeight: "16px",
    color: "#98A2B3",
  },
  emailPortalSubject: {
    fontFamily: "Manrope",
    fontSize: "13px",
    fontWeight: 600,
    lineHeight: "18px",
    color: "#475467",
    marginBottom: "2px",
  },
  emailPortalSnippet: {
    fontFamily: "Manrope",
    fontSize: "12px",
    lineHeight: "16px",
    color: "#98A2B3",
  },
  emailPortalContent: {
    flex: 1,
    minWidth: 0,
    display: "flex",
    flexDirection: "column",
    minHeight: 0,
    backgroundColor: colors.white,
  },
  previewBrowserChromeFullScreen: {
    display: "flex",
    alignItems: "center",
    gap: "12px",
    padding: "8px 16px",
    backgroundColor: colors.gray200,
  },
  previewBodyShellFullScreen: {
    display: "flex",
    flexDirection: "column",
    gap: 0,
    padding: "24px 24px 32px",
    backgroundColor: colors.white,
    flex: 1,
    minHeight: 0,
    overflowY: "auto",
    overflowX: "hidden",
  },
  "@media (max-width: 1100px)": {
    emailPortalBody: {
      flexDirection: "column",
    },
    emailPortalSidebar: {
      width: "100%",
      minWidth: "100%",
      maxHeight: "260px",
      borderRight: "none",
      borderBottom: `1px solid ${colors.gray200}`,
    },
  },
  previewSection: {
    position: "relative",
    backgroundColor: "transparent",
    borderRadius: 0,
    border: "none",
    padding: "32px 0 16px",
    "&:not(:first-of-type)": {
      paddingTop: "24px",
    },
  },
  previewBadge: {
    position: "absolute",
    top: "12px",
    right: "12px",
    padding: "2px 8px",
    borderRadius: "999px",
    fontFamily: "Manrope",
    fontSize: "10px",
    fontWeight: 600,
    letterSpacing: "0.5px",
    color: "#98A2B3",
    backgroundColor: "rgba(102, 112, 133, 0.12)",
  },
  previewHeader: {
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
    gap: "16px",
  },
  previewLogo: {
    fontFamily: "Manrope",
    fontWeight: 700,
    fontSize: "18px",
    color: colors.brandBlue500,
  },
  previewHeaderInfo: {
    fontFamily: "Manrope",
    fontSize: "14px",
    color: "#475467",
  },
  previewBody: {
    minHeight: "280px",
  },
  previewHtml: {
    fontFamily: "Manrope",
    fontSize: "14px",
    lineHeight: "24px",
    color: "#344054",
    wordBreak: "break-word",
    overflowWrap: "break-word",
  },
  previewPlaceholder: {
    fontFamily: "Manrope",
    fontSize: "14px",
    lineHeight: "20px",
    color: "#98A2B3",
    fontStyle: "italic",
    textAlign: "center",
  },
  previewFooter: {
    display: "flex",
    flexDirection: "column",
    gap: "4px",
    alignItems: "center",
  },
  previewFooterText: {
    fontFamily: "Manrope",
    fontSize: "12px",
    color: "#344054",
  },
  joditOverrides: {
    ".jodit_theme_email": {
      "& .jodit-container": {
        border: "none !important",
        boxShadow: "none !important",
      },
      "& .jodit-toolbar__box": {
        backgroundColor: "transparent",
        border: "none",
        padding: 0,
        boxShadow: "none",
        display: "flex",
        flexWrap: "nowrap",
        gap: "6px",
        overflowX: "auto",
      },
      "& .jodit-toolbar__box:first-of-type": {
        marginBottom: "8px",
      },
      "& .jodit-toolbar__box:last-of-type": {
        justifyContent: "flex-start",
        gap: "6px",
      },
      "& .jodit-toolbar-button": {
        minWidth: "32px",
        height: "32px",
        border: `1px solid ${colors.gray200 || "#E5E7EB"} !important`,
        borderRadius: "6px",
        backgroundColor: colors.white || "#FFFFFF",
        boxShadow: "0px 1px 2px rgba(16, 24, 40, 0.05)",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        padding: "0 6px",
        "&:hover": {
          backgroundColor: colors.gray100 || "#F3F4F6",
          borderColor: colors.gray300 || "#D0D5DD !important",
        },
        "&.jodit_active": {
          backgroundColor: "#E8F2FF",
          color: "#1976D2",
          borderColor: "#CDE4FF",
        },
        "& svg": {
          width: "18px",
          height: "18px",
        },
      },
      "& .jodit-toolbar-button_image svg": {
        filter: "invert(100%)",
      },
      "& .jodit-toolbar__box:last-of-type .jodit-toolbar-button_with-dropdown": {
        borderRadius: "18px",
        padding: "0 16px",
        height: "36px",
        fontWeight: 500,
        color: "#374151",
        backgroundColor: "#FFFFFF",
        border: `1px solid ${colors.gray300 || "#D1D5DB"}`,
        "&:hover": {
          backgroundColor: colors.gray50 || "#F9FAFB",
          borderColor: colors.gray400 || "#9CA3AF",
        },
      },
      "& .jodit-toolbar-button.jodit-toolbar__separator": {
        background: "transparent !important",
        width: "4px",
        margin: "0",
        border: "none",
        boxShadow: "none",
      },
      "& .jodit-workplace": {
        border: `1px solid ${colors.gray200 || "#E5E7EB"}`,
        borderRadius: "8px",
        marginTop: "16px",
        minHeight: "400px",
      },
    },
  },
  attachmentsContainer: {
    display: "flex",
    gap: "24px",
    width: "100%",
    alignItems: "flex-start",
    "@media (max-width: 960px)": {
      flexDirection: "column",
    },
  },
}));

export default useStyles;
